.editor {
    flex-grow: 1;
}
